// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__UuPZr","colCheckbox":"styles_colCheckbox__2XaCP"};